/*** IMPORTS FROM imports-loader ***/

(function() {
if (!Array.prototype.indexOf) {
	Array.prototype.indexOf = function indexOf(searchElement) {
		for (var array = this, index = 0, length = array.length; index < length; ++index) {
			if (array[index] === searchElement) {
				return index;
			}
		}

		return -1;
	};
}

if (!Array.prototype.filter) {
	Array.prototype.filter = function filter(callback, scope) {
		for (var array = this, arrayB = [], index = 0, length = array.length, element; index < length; ++index) {
			element = array[index];

			if (callback.call(scope || window, element, index, array)) {
				arrayB.push(element);
			}
		}

		return arrayB;
	};
}

if (!Array.prototype.find) {
	Array.prototype.find = function (predicate, context) {
		var value;

		if (typeof predicate !== 'function') {
			throw new TypeError('predicate must be a function');
		}

		for (var i = 0, length = this.length >>> 0; i < length; i++) {
			value = this[i];

			if (predicate.call(context, value, i, this)) {
				return value;
			}
		}
	};
}

if (!Array.prototype.findIndex) {
	Object.defineProperty(Array.prototype, 'findIndex', {
		value: function (predicate) {
			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			var o = Object(this);
			var len = o.length >>> 0;

			if (typeof predicate !== 'function') {
				throw new TypeError('predicate must be a function');
			}

			var thisArg = arguments[1];

			var k = 0;

			while (k < len) {
				var kValue = o[k];
				if (predicate.call(thisArg, kValue, k, o)) {
					return k;
				}
				k++;
			}

			return -1;
		},
		configurable: true,
		writable: true
	});
}

if (!Array.prototype.reduce) {
	Array.prototype.reduce = function (callback/*, initialValue*/) {
		if (typeof callback !== 'function') {
			throw new TypeError(callback + ' is not a function');
		}

		var length = this.length >>> 0,
			key = 0,
			value;

		if (arguments.length == 2) {
			value = arguments[1];
		} else {
			while (key < length && !key in this) {
				key++;
			}

			if (key >= length) {
				throw new TypeError('Reduce of empty array with no initial value');
			}

			value = this[key++];
		}

		for (; key < length; key++) {
			if (key in this) {
				value = callback(value, this[key], key, this);
			}
		}

		return value;
	};
}

if (!Array.prototype.map) {
	Array.prototype.map = function map(callback, context) {
		var result = [];

		for (var index = 0, length = this.length; index < length; ++index) {
			result.push(callback.call(context, this[index], index, this));
		}

		return result;
	};
}

if (!Function.prototype.bind) {
	Function.prototype.bind = function bind(thisArg) {
		var callback = this,
			args = arguments.length > 1 ? Array.prototype.slice.call(arguments, 1) : [];

		return function () {
			return args.length === 0 && arguments.length === 0
				? callback.call(thisArg)
				: callback.apply(thisArg, args.concat(Array.prototype.slice.call(arguments, 0)));
		};
	};

}

if (!Array.prototype.forEach) {
	Array.prototype.forEach = function forEach(callback, scope) {
		for (var array = this, index = 0, length = array.length; index < length; ++index) {
			callback.call(scope || window, array[index], index, array);
		}
	};
}

if (!Array.prototype.includes) {
	Array.prototype.includes = function (item, fromIndex) {
		return this.indexOf(item, fromIndex) !== -1;
	};

}

if (typeof window.JSON === 'undefined') {
	/** @license MIT Asen Bozhilov JSON.parse (https://github.com/abozhilov/json) */
	(function () {
		var
			toString = Object.prototype.toString,
			hasOwnProperty = Object.prototype.hasOwnProperty,
			LEFT_CURLY = '{',
			RIGHT_CURLY = '}',
			COLON = ':',
			LEFT_BRACE = '[',
			RIGHT_BRACE = ']',
			COMMA = ',',
			tokenType = {
				PUNCTUATOR: 1,
				STRING: 2,
				NUMBER: 3,
				BOOLEAN: 4,
				NULL: 5
			},
			tokenMap = {
				'{': 1, '}': 1, '[': 1, ']': 1, ',': 1, ':': 1,
				'"': 2,
				't': 4, 'f': 4,
				'n': 5
			},
			escChars = {
				'b': '\b',
				'f': '\f',
				'n': '\n',
				'r': '\r',
				't': '\t',
				'"': '"',
				'\\': '\\',
				'/': '/'
			},
			tokenizer = /^(?:[{}:,\[\]]|true|false|null|"(?:[^"\\\u0000-\u001F]|\\["\\\/bfnrt]|\\u[0-9A-F]{4})*"|-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)/,
			whiteSpace = /^[\t ]+/,
			lineTerminator = /^\r?\n/;

		function JSONLexer(JSONStr) {
			this.line = 1;
			this.col = 1;
			this._tokLen = 0;
			this._str = JSONStr;
		}

		JSONLexer.prototype = {
			getNextToken: function () {
				var
					str = this._str,
					token, type;

				this.col += this._tokLen;

				if (!str.length) {
					return 'END';
				}

				token = tokenizer.exec(str);

				if (token) {
					type = tokenMap[token[0].charAt(0)] || tokenType.NUMBER;
				} else if ((token = whiteSpace.exec(str))) {
					this._tokLen = token[0].length;
					this._str = str.slice(this._tokLen);
					return this.getNextToken();
				} else if ((token = lineTerminator.exec(str))) {
					this._tokLen = 0;
					this._str = str.slice(token[0].length);
					this.line++;
					this.col = 1;
					return this.getNextToken();
				} else {
					this.error('Invalid token');
				}

				this._tokLen = token[0].length;
				this._str = str.slice(this._tokLen);

				return {
					type: type,
					value: token[0]
				};
			},

			error: function (message, line, col) {
				var err = new SyntaxError(message);

				err.line = line || this.line;
				err.col = col || this.col;

				throw err;
			}
		};

		function JSONParser(lexer) {
			this.lex = lexer;
		}

		JSONParser.prototype = {
			parse: function () {
				var lex = this.lex, jsValue = this.getValue();

				if (lex.getNextToken() !== 'END') {
					lex.error('Illegal token');
				}

				return jsValue;
			},
			getObject: function () {
				var
					jsObj = {},
					lex = this.lex,
					token, tval, prop,
					line, col,
					pairs = false;

				while (true) {
					token = lex.getNextToken();
					tval = token.value;

					if (tval === RIGHT_CURLY) {
						return jsObj;
					}

					if (pairs) {
						if (tval === COMMA) {
							line = lex.line;
							col = lex.col - 1;
							token = lex.getNextToken();
							tval = token.value;
							if (tval === RIGHT_CURLY) {
								lex.error('Invalid trailing comma', line, col);
							}
						} else {
							lex.error('Illegal token where expect comma or right curly bracket');
						}
					} else if (tval === COMMA) {
						lex.error('Invalid leading comma');
					}

					if (token.type != tokenType.STRING) {
						lex.error('Illegal token where expect string property name');
					}

					prop = this.getString(tval);

					token = lex.getNextToken();
					tval = token.value;

					if (tval != COLON) {
						lex.error('Illegal token where expect colon');
					}

					jsObj[prop] = this.getValue();
					pairs = true;
				}
			},
			getArray: function () {
				var
					jsArr = [],
					lex = this.lex,
					token, tval,
					line, col,
					values = false;

				while (true) {
					token = lex.getNextToken();
					tval = token.value;

					if (tval === RIGHT_BRACE) {
						return jsArr;
					}

					if (values) {
						if (tval === COMMA) {
							line = lex.line;
							col = lex.col - 1;
							token = lex.getNextToken();
							tval = token.value;

							if (tval === RIGHT_BRACE) {
								lex.error('Invalid trailing comma', line, col);
							}
						} else {
							lex.error('Illegal token where expect comma or right square bracket');
						}
					} else if (tval === COMMA) {
						lex.error('Invalid leading comma');
					}

					jsArr.push(this.getValue(token));
					values = true;
				}
			},
			getString: function (strVal) {
				return strVal.slice(1, -1).replace(/\\u?([0-9A-F]{4}|["\\\/bfnrt])/g, function (match, escVal) {
					return escChars[escVal] || String.fromCharCode(parseInt(escVal, 16));
				});
			},
			getValue: function (fromToken) {
				var lex = this.lex,
					token = fromToken || lex.getNextToken(),
					tval = token.value;
				switch (token.type) {
					case tokenType.PUNCTUATOR:
						if (tval === LEFT_CURLY) {
							return this.getObject();
						} else if (tval === LEFT_BRACE) {
							return this.getArray();
						}

						lex.error('Illegal punctoator');

						break;
					case tokenType.STRING:
						return this.getString(tval);
					case tokenType.NUMBER:
						return Number(tval);
					case tokenType.BOOLEAN:
						return tval === 'true';
					case tokenType.NULL:
						return null;
					default:
						lex.error('Invalid value');
				}
			}
		};

		function filter(base, prop, value) {
			if (typeof value === 'undefined') {
				delete base[prop];
				return;
			}
			base[prop] = value;
		}

		function walk(holder, name, rev) {
			var val = holder[name], i, len;

			if (toString.call(val).slice(8, -1) === 'Array') {
				for (i = 0, len = val.length; i < len; i++) {
					filter(val, i, walk(val, i, rev));
				}
			} else if (typeof val === 'object') {
				for (i in val) {
					if (hasOwnProperty.call(val, i)) {
						filter(val, i, walk(val, i, rev));
					}
				}
			}

			return rev.call(holder, name, val);
		}

		function pad(value, length) {
			value = String(value);

			return value.length >= length ? value : new Array(length - value.length + 1).join('0') + value;
		}

		window.JSON = {
			parse: function (JSONStr, reviver) {
				var jsVal = new JSONParser(new JSONLexer(JSONStr)).parse();

				if (typeof reviver === 'function') {
					return walk({
						'': jsVal
					}, '', reviver);
				}

				return jsVal;
			},
			stringify: function () {
				var
					value = arguments[0],
					replacer = typeof arguments[1] === 'function' ? arguments[1] : null,
					space = arguments[2] || '',
					spaceSpace = space ? ' ' : '',
					spaceReturn = space ? '\n' : '',
					className = toString.call(value).slice(8, -1),
					array, key, hasKey, index, length, eachValue;

				if (value === null || className === 'Boolean' || className === 'Number') {
					return value;
				}

				if (className === 'Array') {
					array = [];

					for (length = value.length, index = 0, eachValue; index < length; ++index) {
						eachValue = replacer ? replacer(index, value[index]) : value[index];
						eachValue = this.stringify(eachValue, replacer, space);

						if (eachValue === undefined || eachValue === null) {
							eachValue = 'null';
						}

						array.push(eachValue);
					}

					return '[' + spaceReturn + array.join(',' + spaceReturn).replace(/^/mg, space) + spaceReturn + ']';
				}

				if (className === 'Date') {
					return '"' + value.getUTCFullYear() + '-' +
						pad(value.getUTCMonth() + 1, 2) + '-' +
						pad(value.getUTCDate(), 2) + 'T' +
						pad(value.getUTCHours(), 2) + ':' +
						pad(value.getUTCMinutes(), 2) + ':' +
						pad(value.getUTCSeconds(), 2) + '.' +
						pad(value.getUTCMilliseconds(), 3) + 'Z' + '"';
				}

				if (className === 'String') {
					return '"' + value.replace(/"/g, '\\"') + '"';
				}

				if (typeof value === 'object') {
					array = [];
					hasKey = false;

					for (key in value) {
						if (hasOwnProperty.call(value, key)) {
							eachValue = replacer ? replacer(key, value[key]) : value[key];
							eachValue = this.stringify(eachValue, replacer, space);

							if (eachValue !== undefined) {
								hasKey = true;

								array.push('"' + key + '":' + spaceSpace + eachValue);
							}
						}
					}

					if (!hasKey) {
						return '{}';
					} else {
						return '{' + spaceReturn + array.join(',' + spaceReturn).replace(/^/mg, space) + spaceReturn + '}';
					}
				}
			}
		};
	})();
}

if (typeof Object !== 'undefined' && !Object.keys) {
	Object.keys = function keys(object) {
		var buffer = [], key;

		for (key in object) {
			if (Object.prototype.hasOwnProperty.call(object, key)) {
				buffer.push(key);
			}
		}

		return buffer;
	};
}

if (!Object.assign) {
	Object.assign = function (target) {
		if (target === undefined || target === null) {
			throw new TypeError('Cannot convert undefined or null to object');
		}

		var output = Object(target);

		for (var index = 1; index < arguments.length; index++) {
			var source = arguments[index];

			if (source !== undefined && source !== null) {
				for (var nextKey in source) {
					if (source.hasOwnProperty(nextKey)) {
						output[nextKey] = source[nextKey];
					}
				}
			}
		}

		return output;
	};
}

if (!String.prototype.trim) {
	String.prototype.trim = function trim() {
		return this.replace(/^\s+|\s+$/g, '');
	};
}

if (!String.prototype.includes) {
	String.prototype.includes = function () {
		'use strict';
		return String.prototype.indexOf.apply(this, arguments) !== -1;
	};
}

if (!Array.prototype.some) {
	Array.prototype.some = function some(callback, scope) {
		for (var array = this, index = 0, length = array.length; index < length; ++index) {
			if (callback.call(scope || window, array[index], index, array)) {
				return true;
			}
		}

		return false;
	};
}

if (!Array.isArray) {
	Array.isArray = function isArray(array) {
		return array && Object.prototype.toString.call(array) === '[object Array]';
	};
}

if (!Date.now) {
	Date.now = function () {
		return new Date().getTime();
	};
}

if (!Date.prototype.toISOString) {
	(function () {
		function pad(number) {
			if (number < 10) {
				return '0' + number;
			}

			return number;
		}

		Date.prototype.toISOString = function toISOString() {
			return this.getUTCFullYear() +
				'-' + pad(this.getUTCMonth() + 1) +
				'-' + pad(this.getUTCDate()) +
				'T' + pad(this.getUTCHours()) +
				':' + pad(this.getUTCMinutes()) +
				':' + pad(this.getUTCSeconds()) +
				'.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
				'Z';
		};
	})();
}

Number.isNaN = Number.isNaN || function (value) {
	return typeof value === 'number' && isNaN(value);
};

if (typeof Object.create != 'function') {
	Object.create = (function () {
		var result,
			Temp = function () {
			};

		return function (prototype, propertiesObject) {
			if (typeof prototype != 'object') {
				throw TypeError('Argument must be an object');
			}

			Temp.prototype = prototype;
			result = new Temp();
			Temp.prototype = null;

			if (propertiesObject) {
				Object.keys(propertiesObject).forEach(function (key) {
					result[key] = propertiesObject[key].value;
				});
			}

			return result;
		};
	})();
}

/**
 * requestAnimationFrame polyfill v1.0.0
 * requires Date.now
 *
 * © Polyfiller 2015
 * Released under the MIT license
 * github.com/Polyfiller/requestAnimationFrame
 */
window.requestAnimationFrame || function (window) {

	'use strict';

	window.requestAnimationFrame = window.msRequestAnimationFrame
		|| window.mozRequestAnimationFrame
		|| window.webkitRequestAnimationFrame
		|| function () {

			var fps = 60;
			var delay = 1000 / fps;
			var animationStartTime = Date.now();
			var previousCallTime = animationStartTime;

			return function requestAnimationFrame(callback) {

				var requestTime = Date.now();
				var timeout = Math.max(0, delay - (requestTime - previousCallTime));
				var timeToCall = requestTime + timeout;

				previousCallTime = timeToCall;

				return window.setTimeout(function onAnimationFrame() {

					callback(timeToCall - animationStartTime);

				}, timeout);
			};
		}();

	window.cancelAnimationFrame = window.mozCancelAnimationFrame
		|| window.webkitCancelAnimationFrame
		|| window.cancelRequestAnimationFrame
		|| window.msCancelRequestAnimationFrame
		|| window.mozCancelRequestAnimationFrame
		|| window.webkitCancelRequestAnimationFrame
		|| function cancelAnimationFrame(id) {
			window.clearTimeout(id);
		};

}(this);

try {
	// https://gist.github.com/edoardocavazza/47246856759f2273e48b
	(function () {
		if (typeof Object.setPrototypeOf === 'undefined' && typeof Object.getOwnPropertyNames === 'function') {
			var _exclude = ['length', 'name', 'arguments', 'caller', 'prototype'];

			function bindFunction(ctx, fn) {
				return function () {
					return fn.apply(this, arguments);
				};
			}

			function bindProperty(ctx, prop, parentDescriptor) {
				if (!parentDescriptor) {
					var defaultValue = ctx.__proto__[prop];
					parentDescriptor = {
						get: function () {
							return ctx['__' + prop] || defaultValue;
						},
						set: function (val) {
							ctx['__' + prop] = val;
						}
					};
				}
				Object.defineProperty(ctx, prop, {
					get: parentDescriptor.get ? parentDescriptor.get.bind(ctx) : undefined,
					set: parentDescriptor.set ? parentDescriptor.set.bind(ctx) : undefined,
					configurable: true
				});

			}

			function iterateProps(subClass, superClass) {
				var props = Object.getOwnPropertyNames(superClass),
					proto;

				subClass.__proto__ = superClass;
				for (var i = 0, len = props.length; i < len; i++) {
					var prop = props[i];
					if (prop === '__proto__') {
						proto = superClass[prop];
					} else if (_exclude.indexOf(i) === -1) {
						var descriptor = Object.getOwnPropertyDescriptor(subClass, prop);
						if (!descriptor) {
							var superDescriptor = Object.getOwnPropertyDescriptor(superClass, prop);
							if (typeof superDescriptor.get !== 'function' && typeof superClass[prop] === 'function') {
								subClass[prop] = bindFunction(subClass, superClass[prop]);
							} else if (typeof superDescriptor.get == 'function') {
								bindProperty(subClass, prop, superDescriptor);
							} else {
								bindProperty(subClass, prop);
							}
						}
					}
				}
				if (proto) {
					iterateProps(subClass, proto);
				}
			}

			Object.setPrototypeOf = iterateProps;
		}
	})();
} catch (e) {
	// ignore
}

if (!String.prototype.repeat) {
	String.prototype.repeat = function (count) {
		'use strict';
		if (this == null) {
			throw new TypeError('can\'t convert ' + this + ' to object');
		}
		var str = '' + this;
		count = +count;
		if (count != count) {
			count = 0;
		}
		if (count < 0) {
			throw new RangeError('repeat count must be non-negative');
		}
		if (count == Infinity) {
			throw new RangeError('repeat count must be less than infinity');
		}
		count = Math.floor(count);
		if (str.length == 0 || count == 0) {
			return '';
		}
		// Обеспечение того, что count является 31-битным целым числом, позволяет нам значительно
		// соптимизировать главную часть функции. Впрочем, большинство современных (на август
		// 2014 года) браузеров не обрабатывают строки, длиннее 1 << 28 символов, так что:
		if (str.length * count >= 1 << 28) {
			throw new RangeError('repeat count must not overflow maximum string size');
		}
		var rpt = '';
		for (var i = 0; i < count; i++) {
			rpt += str;
		}
		return rpt;
	};
}
if (!String.prototype.padStart) {
	String.prototype.padStart = function padStart(targetLength, padString) {
		targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
		padString = String(padString || ' ');
		if (this.length > targetLength) {
			return String(this);
		} else {
			targetLength = targetLength - this.length;
			if (targetLength > padString.length) {
				padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
			}
			return padString.slice(0, targetLength) + String(this);
		}
	};
}
if (!String.prototype.padEnd) {
	String.prototype.padEnd = function padEnd(targetLength, padString) {
		targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
		padString = String((typeof padString !== 'undefined' ? padString : ' '));
		if (this.length > targetLength) {
			return String(this);
		} else {
			targetLength = targetLength - this.length;
			if (targetLength > padString.length) {
				padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
			}
			return String(this) + padString.slice(0, targetLength);
		}
	};
}
if (!Array.prototype.fill) {
	Object.defineProperty(Array.prototype, 'fill', {
		value: function (value) {

			// Шаги 1-2.
			if (this == null) {
				throw new TypeError('this is null or not defined');
			}

			var O = Object(this);

			// Шаги 3-5.
			var len = O.length >>> 0;

			// Шаги 6-7.
			var start = arguments[1];
			var relativeStart = start >> 0;

			// Шаг 8.
			var k = relativeStart < 0 ?
				Math.max(len + relativeStart, 0) :
				Math.min(relativeStart, len);

			// Шаги 9-10.
			var end = arguments[2];
			var relativeEnd = end === undefined ?
				len : end >> 0;

			// Шаг 11.
			var final = relativeEnd < 0 ?
				Math.max(len + relativeEnd, 0) :
				Math.min(relativeEnd, len);

			// Шаг 12.
			while (k < final) {
				O[k] = value;
				k++;
			}

			// Шаг 13.
			return O;
		}
	});
}

}.call(window));
